module.exports = __webpack_public_path__ + "img/624.38789808.png";